var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-image': ("url('" + (require('@/assets/background-login.jpg')) + "')")},
    {'background-repeat': 'repeat'}
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-content',{staticStyle:{"height":"100vh"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('user-form',{attrs:{"user-data":_vm.user,"is-my-account":"","parent-route":"/","back-button-text":"Pagina principal"}})],1)])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c01694a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/user-account.vue
// module id = null
// module chunks = 